// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2rFEV","checkboxCol":"Table_checkboxCol__3JqLQ","emailCol":"Table_emailCol__dIYSx","actionCol":"Table_actionCol__3zacN"};